// extracted by mini-css-extract-plugin
export default {"rating":"oA-z","numberOfStars":"pA-z","count":"qA-z","barGraphSpacing":"rA-z","barGraph":"sA-z"};